module.exports = __webpack_public_path__ + "img/4@2x.74bb19b0.png";